module.exports = __webpack_public_path__ + "static/media/cursor.25bb61d3.svg";